<div #inputField
     [attr.contenteditable]="editEnabled"
     [innerHTML]="previewText"
     [attr.placeholder]="placeholder"
     (click)="edit()"
     (blur)="applyChanges()"
     class="brn-input"
></div>
